import FormPage, { FormPageTop } from '@chegg-wt/core/components/Layouts/Form'
import { TopContentWrapper } from '@chegg-wt/core/components/AdFrame/'
import React from 'react'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { AppState } from '@chegg-wt/core/state'
import { connect } from 'react-redux'
import { getSourceTypeName } from '@chegg-wt/core/utils/sourceTypes'
import { createCitationSourceTypeSelector } from '@chegg-wt/core/state/createCitation/selectors'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { lvpLayoutSelector } from '@chegg-wt/core/state/featureFlags/selectors'
import { getCapitalizedSEONameOfStyle } from '@chegg-wt/core/utils/styles'
import { getUrlStyle } from '@chegg-wt/core/server/utils/redirect'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { formB1 } from '../../../copy/CMSContent'

interface EditPageProps {
  style: string
  source: string
  isLvp: boolean
}

const EditPage: NextPageWithLayout<EditPageProps> = ({ style, source, isLvp }) => {
  const formattedStyle = getCapitalizedSEONameOfStyle(getUrlStyle(style))
  useOnUnloadTimeOnPage()

  return (
    <>
      <SEOTitle
        title={`Citation Form | ${formattedStyle} | ${getSourceTypeName(
          source
        )} | Cite This For Me`}
      />
      {!isLvp && (
        <TopContentWrapper>
          <FormPageTop />
        </TopContentWrapper>
      )}
      <FormPage route="toEditCitation" formType="edit" copy={formB1} />
    </>
  )
}

EditPage.getPageLayout = (page) => getLvpLayout(page, () => <FormPageTop />)

const mapStateToProps = (state: AppState) => ({
  style: currentStyleSelector(state),
  source: createCitationSourceTypeSelector(state),
  isLvp: lvpLayoutSelector(state),
})

export default connect(mapStateToProps)(EditPage)
